import { Workbox } from 'workbox-window';

class ServiceWorkerService {
  constructor() {
    this.wb = null;
    this.isUpdateAvailable = false;
    this.updateListeners = new Set();
  }

  async register() {
    if ('serviceWorker' in navigator) {
      try {
        // In development, Workbox will generate the SW at /sw.js
        // In production, it will be at the same location
        this.wb = new Workbox(process.env.NODE_ENV === 'production' ? '/sw.js' : '/sw.js');

        // Listen for update available
        this.wb.addEventListener('waiting', () => {
          this.isUpdateAvailable = true;
          this.notifyUpdateListeners(true);
        });

        // Listen for controlling (new SW activated)
        this.wb.addEventListener('controlling', () => {
          window.location.reload();
        });

        // Listen for messages from service worker
        this.wb.addEventListener('message', (event) => {
          if (event.data?.type === 'BACKGROUND_SYNC_REQUESTED') {
            // Notify app that background sync is requested
            window.dispatchEvent(new CustomEvent('background-sync-requested'));
          }
        });

        // Register the service worker
        await this.wb.register();
        
        // console.log('Service Worker registered successfully');
        return true;
      } catch (error) {
        console.error('Service Worker registration failed:', error);
        return false;
      }
    } else {
      console.warn('Service Workers are not supported in this browser');
      return false;
    }
  }

  // Update the service worker
  async update() {
    if (this.wb && this.isUpdateAvailable) {
      // Tell the waiting SW to skip waiting and become active
      this.wb.messageSkipWaiting();
      this.isUpdateAvailable = false;
      this.notifyUpdateListeners(false);
    }
  }

  // Add listener for update notifications
  addUpdateListener(callback) {
    this.updateListeners.add(callback);
    return () => this.updateListeners.delete(callback);
  }

  // Notify all listeners about update status
  notifyUpdateListeners(updateAvailable) {
    this.updateListeners.forEach(callback => {
      try {
        callback(updateAvailable);
      } catch (error) {
        console.error('Error in update listener:', error);
      }
    });
  }

  // Check if update is available
  isUpdateReady() {
    return this.isUpdateAvailable;
  }

  // Register for background sync
  async registerBackgroundSync() {
    if ('serviceWorker' in navigator && 'sync' in window.ServiceWorkerRegistration.prototype) {
      try {
        const registration = await navigator.serviceWorker.ready;
        await registration.sync.register('background-sync');
        // console.log('Background sync registered');
        return true;
      } catch (error) {
        console.error('Background sync registration failed:', error);
        return false;
      }
    }
    return false;
  }

  // Send message to service worker
  async sendMessage(message) {
    if (this.wb) {
      try {
        await this.wb.messageSW(message);
      } catch (error) {
        console.error('Failed to send message to service worker:', error);
      }
    }
  }
}

export const serviceWorkerService = new ServiceWorkerService();
